import axios from 'axios';
import {EventData, ProjectData,PostData, FormData, ColabFormData, SearchFormat} from '../interface';

// const url = 'http://localhost:5000/posts';
// const url = 'https://flare-sustainablegame-api.herokuapp.com/posts';

// export const fetchPosts = ()=> axios.get(url);
// export const createPost = (newPost:PostData) => axios.post(url, newPost);
// export const updatePost = (id:string,updatedPost:PostData) => axios.patch(`${url}/${id}`, updatedPost);
// export const deletePost = (id:string) => axios.delete(`${url}/${id}`);
// export const likePost = (id:string) => axios.patch(`${url}/${id}/likePost`);


// export const signIn = (formData) => API.post('/user/signin', formData);
// export const signUp = (formData) => API.post('/user/signup', formData);


// const API = axios.create({ baseURL: 'http://localhost:5000' });
const API = axios.create({ baseURL: process.env.REACT_APP_SERVER });

API.interceptors.request.use((req) => {
  if (localStorage.getItem('profile')) {
    req.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem('profile')||"").token}`;
  }

  return req;
});

export const fetchProject = (id:any) => API.get(`/projects/${id}`);
export const fetchProjects = (page:Number) => API.get(`/projects?page=${page}`);
export const fetchProjectsBySearch = (searchQuery: SearchFormat, page:Number) => API.get(`/projects/search?searchQuery=${searchQuery.search ||""}&tags=${searchQuery.tags}&page=${page}`);
export const createProject = (newProject:ProjectData) => API.post('/projects', newProject);
export const likeProject = (id:any) => API.patch(`/projects/${id}/likeProject`);
export const colabProject = (id:any, colabFormData: ColabFormData) => API.patch(`/projects/${id}/colabProject`, colabFormData);
export const updateProject = (id:any,updatedProject:ProjectData) => API.patch(`/projects/${id}`, updatedProject);
export const deleteProject = (id:any) => API.delete(`/projects/${id}`);

export const fetchEvent = (id:any) => API.get(`/projects/${id}`);
export const fetchEvents = (page:Number) => API.get(`/projects?page=${page}`);
export const fetchEventsBySearch = (searchQuery: SearchFormat, page:Number) => API.get(`/projects/search?searchQuery=${searchQuery.search ||""}&tags=${searchQuery.tags}&page=${page}`);
export const createEvent = (newEvent:EventData) => API.post('/projects', newEvent);
export const likeEvent = (id:any) => API.patch(`/projects/${id}/likeEvent`);
export const updateEvent = (id:any,updatedEvent:ProjectData) => API.patch(`/projects/${id}`, updatedEvent);
export const deleteEvent = (id:any) => API.delete(`/projects/${id}`);

export const fetchPost = (id:any) => API.get(`/posts/${id}`);
export const fetchPosts = (page:Number) => API.get(`/posts?page=${page}`);
export const fetchPostsBySearch = (searchQuery: SearchFormat, page:Number) => API.get(`/posts/search?searchQuery=${searchQuery.search ||""}&tags=${searchQuery.tags}&page=${page}`);
export const createPost = (newPost:PostData) => API.post('/posts', newPost);
export const likePost = (id:any) => API.patch(`/posts/${id}/likePost`);
export const updatePost = (id:any,updatedPost:PostData) => API.patch(`/posts/${id}`, updatedPost);
export const deletePost = (id:any) => API.delete(`/posts/${id}`);

export const signIn = (formData:FormData) => API.post('/user/signin', formData);
export const signUp = (formData:FormData) => API.post('/user/signup', formData);